// Packages
import tw, { styled, css } from "twin.macro";
import HorizontalFlourish from "../../_images/horizontal-flourish.svg";

export const Container = styled.div(() => [
  ``,
  tw`container mx-auto text-white pt-10 md:pt-10 text-[#333333]`,
]);

export const Title = styled.h1(() => [
  tw` text-title uppercase pb-2 text-center font-bold md:text-center md:text-5xl leading-none md:leading-[1.2]`,
]);

export const Standfirst = styled.h1(({ className }) => [
  `letter-spacing: -0.41px;`,
  tw`text-title uppercase pb-8 text-center font-thin leading-none md:leading-snug md:text-center md:pb-8 md:text-[46px]`,
  className?.includes('de') &&
    `@media (max-width: 768px) { font-size: clamp(20px, 8vw, 30px); }`,
]);


// Modal mask
export const ModalMask = styled.div(() => [
  `background-color: rgba(0,0,0,0.5);`,
  tw`fixed w-full h-full z-50 top-0 left-0`,
]);

const introContent = css`
  p + p {
    margin-top: 1em;
  }
  a {
    &:link,
    &:visited,
    &:hover,
    &:focus,
    &:active {
      text-decoration: underline;
    }
  }
`;

// export const Paragraph = styled.p(() => [
export const Paragraph = styled.div(() => [
  `text-wrap: pretty;`,
  tw`text-introcopy font-light px-4 lg:px-14 text-center md:text-center md:px-0 mx-auto`,
  introContent,
]);

export const TopBanner = styled.div(() => [
  css`
    background: url("${HorizontalFlourish}"),
      linear-gradient(to right, rgba(199, 200, 202, 1), rgba(240, 241, 242, 1));
    background-size: cover;
    background-position: right;
  `,
  tw`text-black text-center px-4 lg:px-14 py-4 mx-auto mt-8`,
]);

export const TcLink = styled.div(() => [
  `a {
    &:link, &:visited, &:hover, &:focus, &:active {
      text-decoration: underline;
    }
    &:focus {
      outline: 1px dashed #fff;
      outline-offset: 3px;
    }
  }`,
  tw`text-introcopy text-[#006FCF] px-4 text-center md:text-center md:px-0 mt-8 mx-auto cursor-pointer`,
]);

export const TcLinkExt = styled.a(() => [
  `a {
    &:link, &:visited, &:hover, &:focus, &:active {
      text-decoration: underline;
    }
    &:focus {
      outline: 1px dashed #fff;
      outline-offset: 3px;
    }
  }`,
  tw`block text-introcopy text-[#006FCF] px-4 text-center md:text-center md:px-0 mt-8 mx-auto cursor-pointer`,
]);

export const HotelRestaurantInfo = styled.div(() => [
  tw`text-copy px-6 text-center px-4 mt-8 mx-auto flex row-auto justify-center`,
  introContent,
]);
